import { createRouter, createWebHistory } from "vue-router";
// import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "newhome",
    meta:{
      title:"首页"
    },
    component: () =>
      import( "../views/newhome.vue"),
  },
  {
    path: "/shangcaixq",
    name: "shangcaixq",
    meta:{
      title:"上蔡县情"
    },
    component: () =>
      import( "../views/shangcaixq.vue"),
  },
  {
    path: "/shangcaixq1",
    name: "shangcaixq1",
    meta:{
      title:"上蔡县情1"
    },
    component: () =>
      import( "../views/shangcaixq1.vue"),
  },
  {
    path: "/xianqing1",
    name: "xianqing1",
    meta:{
      title:"园区总览"
    },
    component: () =>
      import( "../views/xianqing1.vue"),
  },{
    path: "/sanchan1",
    name: "sanchan1",
    meta:{
      title:"三产融合1-丝瓜"
    },
    component: () =>
      import( "../views/Sanchan1.vue"),
  },{
    path: "/sanchan1_hongshu",
    name: "sanchan1_hongshu",
    meta:{
      title:"三产融合1-红薯"
    },
    component: () =>
      import( "../views/Sanchan1_hongshu.vue"),
  },
  {
    path: "/yingyangcan",
    name: "yingyangcan",
    meta:{
      title:"营养餐"
    },
  component: () =>
    import( "../views/yingyangcan.vue"),
},{
    path: "/xiaofeiData",
    name: "xiaofeiData",
    meta:{
      title:"活力三产"
    },
    component: () =>
      import( "../views/XiaofeiData.vue"),
  },
  {
    path: "/sanchan2",
    name: "sanchan2",
    meta:{
      title:"实力二产"
    },
    component: () =>
      import( "../views/Sanchan2.vue"),
  },
  {
    path: "/pinpaiyichang",
    name: "pinpaiyichang",
    meta:{
      title:"品牌一产"
    },
    component: () =>
      import( "../views/pinpaiyichang.vue"),
  },
  {
    path: "/sanchan11",
    name: "sanchan11",
    meta:{
      title:"品牌一产"
      // 27个视频
    },
    component: () =>
      import( "../views/sanchan11.vue"),
  },
  {
    path: "/yuanqu",
    name: "yuanqu",
    meta:{
      title:"园区"
    },
    component: () =>
      import( "../views/Yuanqu.vue"),
  }, {
    path: "/gbnthome",
    name: "gbnthome",
    meta:{
      title:"农业首页"
    },
    component: () =>
      import( "../views/gbnthome.vue"),
  },
  {
    path: "/nyhongshu",
    name: "nyhongshu",
    meta:{
      title:"数字农业-红薯"
    },
    component: () =>
      import( "../views/Nyhongshu.vue"),
  },
  {
    path: "/nongye1",
    name: "nongye1",
    meta:{
      title:"农业1"
    },
    component: () =>
      import( "../views/nongye1.vue"),
  },
  {
    path: "/nongyecx",
    name: "nongyecx",
    meta:{
      title:"农业产销"
    },
    component: () =>
      import( "../views/nongyecx.vue"),
  }, {
    path: "/gbzntyj",
    name: "gbzntyj",
    meta:{
      title:"运营状态"
    },
    component: () =>
      import( "../views/gbzntyj.vue"),
  },{
    path: "/plant",
    name: "plant",
    meta:{
      title:"高标农田"
    },
    component: () =>
      import( "../views/Plant.vue"),
  },{
    path: "/gbyunying",
    name: "gbyunying",
    meta:{
      title:"高标运营"
    },
    component: () =>
      import( "../views/gbyunying.vue"),
  },{
    path: "/plantmoxing",
    name: "plantmoxing",
    meta:{
      title:"种植模型"
    },
    component: () =>
      import( "../views/Plantmoxing.vue"),
  },{
    path: "/qihouYj",
    name: "qihouYj",
    meta:{
      title:"气候灾害预警"
    },
    component: () =>
      import( "../views/QihouYj.vue"),
  },,{
    path: "/zhinengGG",
    name: "zhinengGG",
    meta:{
      title:"智能灌溉"
    },
    component: () =>
      import( "../views/ZhinengGG.vue"),
  },{
    path: "/binghai",
    name: "binghai",
    meta:{
      title:"病虫害管理"
    },
    component: () =>
      import( "../views/Binghai.vue"),
  },{
    path: "/suyuan",
    name: "suyuan",
    meta:{
      title:"农业溯源"
    },
    component: () =>
      import( "../views/Sunyuan.vue"),
  },{
    path: "/fuwu",
    name: "fuwu",
    meta:{
      title:"农业溯源"
    },
    component: () =>
      import( "../views/Fuwu.vue"),
  },




  // 园区总览--暂废弃
  {
    path: "/yuanquzl",
    name: "Yuanquzl",
    meta:{
      title:"园区总览"
    },
    component: () =>
      import( "../views/Yuanquzl.vue"),
  },
  // 消费-电商直播看板--暂废弃
  {
    path: "/zhibo",
    name: "zhibo",
    meta:{
      title:"消费-电商直播看板"
    },
    component: () =>
      import( "../views/Zhibo.vue"),
  }
  ,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
